import { useTranslate } from '@repo/shared/hooks'
import { z } from 'zod'

export const useQuickTradeSchema = () => {
  const { t } = useTranslate()
  const quickTradeSchema = z.object({
    asset: z
      .string({
        required_error: t('quickTrade_validation_asset_required'),
      })
      .min(1, { message: t('quickTrade_validation_asset_required') }),
    meters: z
      .number({
        required_error: t('quickTrade_validation_meters_required'),
        invalid_type_error: t('quickTrade_validation_meters_invalid'),
      })
      .min(1, { message: t('quickTrade_validation_meters_min') })
      .max(10, { message: t('quickTrade_validation_meters_max') }),
  })

  return { quickTradeSchema }
}
